<template>
  <!--prettier-ignore-->
  <div
    class="tw-text-center tw-space-x-4 tw-bg-neutral-600 tw-py-3 tw-text-xs tw-font-medium tw-text-white"
  >
    Your profile is currently hidden. Toggle available session times on to go live <InertiaLink href="/settings/account/sessions" class="tw-underline">here</InertiaLink>.
  </div>
</template>

<script setup></script>
